<style lang="scss">
@use "assets/scss/components/navbar.scss";
</style>

<template>
  <div class="w-16">
    <!-- Hover detection area for the sidebar -->
    <div class="hover-zone" @mouseover="mouseOver" @mouseleave="mouseLeave">
      <div class="cnavbar white-section w-16 h-full relative !p-0" :disablePadding="true" :expanded="expend">
        <nav @mouseover="navContentHover">
          <div class="top cnav_list">
            <div
              v-for="link in navLinks"
              :key="link.url"
              class="cnav_link relative"
              :class="{ 'active': isActive(link.url) || (link.onboarding && $route.path === '/onboarding') }"
              @click="navigateTo(link)"
            >
              <p class="decorator" />
              <div class="flex gap-2 items-center">
                <i v-if="link.icon.includes('isax')" :class="link.icon" class="aspect-square" />
                <Icon v-else :name="link.icon" class="aspect-square" />
                <!-- Applies the transition class when the text must be visible -->
                <span
                  class="cnav_name"
                  :class="{ 'text-slide-transition': textVisible || expend }"
                  v-show="textVisible || expend"
                >{{ link.name }}</span>
              </div>
            </div>
          </div>
          <!-- The getting-started reminder, at the bottom: `nav` spreads its children to both ends. -->
          <OnboardingNavCard />
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
import { VsAvatar } from "vuesax-ts";
import BentoBlock from "~/components/orders/BentoBlock.vue";
import OnboardingNavCard from "~/components/onboarding/OnboardingNavCard.vue";


export default {
  name: "Navbar",
  components: {
    BentoBlock,
    OnboardingNavCard,
    VsAvatar
  },
  props: {
    navLinks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expend: false,
      textVisible: false, // Controls the text visibility after the animation
      timeouts: {}
    };
  },
  watch: {
    expend(newVal) {
      if (newVal) {
        // When the navbar opens, the text becomes visible immediately
        this.textVisible = true;
      } else {
        // When the navbar closes, the text stays visible during the transition
        // then it is hidden
        clearTimeout(this.timeouts.hideText);
        this.textVisible = true; // Keeps the text visible during the transition

        this.timeouts.hideText = setTimeout(() => {
          this.textVisible = false;
        }, 450); // Slightly longer than the transition to make sure it has ended
      }
    }
  },
  methods: {
    isActive(url) {
      // Determines whether the link is active based on the current URL. The anchor is
      // stripped: `$route.path` never contains it, so a link such as
      // /settings/billing#invoices_history would never be highlighted.
      return this.$route.path === url.split("#")[0];
    },

    navigateTo(link) {
      // The documentation is hosted outside the dashboard: an external link does not
      // go through the router, otherwise Vue Router tries to resolve an absolute
      // URL as an internal path.
      if (link.external) {
        window.open(link.url, "_blank", "noopener,noreferrer");
        return;
      }
      // Navigate to the page regardless of the navbar state
      this.$router.push(link.url);
    },

    mouseOver() {
      // Cancels all scheduled closings
      clearTimeout(this.timeouts.collapse);
      clearTimeout(this.timeouts.hideText);

      if (!this.expend) {
        this.expend = true;
        this.textVisible = true;
      }
    },

    navContentHover() {
      // Keeps the navbar open and the text visible
      clearTimeout(this.timeouts.collapse);
      clearTimeout(this.timeouts.hideText);
      this.textVisible = true;
    },

    mouseLeave() {
      if (this.dropdownIsOpen) return;

      // Start closing the navbar
      this.timeouts.collapse = setTimeout(() => {
        this.expend = false;
        // The watcher on expend will hide the text after the transition
      }, 400);
    }
  }
};
</script>
